var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#5D20C2","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M9.999 19.167c5.062 0 9.166-4.104 9.166-9.167S15.061.833 10 .833C4.936.833.832 4.937.832 10s4.104 9.167 9.167 9.167z","key":0}),React.createElement("path",{"stroke":"#5D20C2","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M10 5v5h5","key":1})]);
}

Clock.defaultProps = {"width":"20","height":"20","fill":"none","viewBox":"0 0 20 20"};

module.exports = Clock;

Clock.default = Clock;
